import { render } from "./StudentsView.vue?vue&type=template&id=8d27e41a&scoped=true"
import script from "./StudentsView.vue?vue&type=script&lang=js"
export * from "./StudentsView.vue?vue&type=script&lang=js"

import "./StudentsView.vue?vue&type=style&index=0&id=8d27e41a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d27e41a"]])

export default __exports__